module.exports = __webpack_public_path__ + "img/product04.69b8300a.jpg";